import { getReactNodeKey } from "client/Misc/reactUtils";
import { Children, PropsWithChildren, ReactElement, ReactNode } from "react";
import { setTrackingId } from "client/Misc/utils";
import styles from "./AppCardList.module.less";

export type AppCardListProps = {
	trackingId: string;
};

export const AppCardList = (props: PropsWithChildren<AppCardListProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	const childrenArray: ReadonlyArray<ReactNode> = Children.toArray(children);

	return (
		<ul
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{childrenArray.map((child, index) => (
				<li
					key={getReactNodeKey(child, index)}
					className={styles.item}
				>
					{child}
				</li>
			))}
		</ul>
	);
};
AppCardList.displayName = "AppCardList";
